// extracted by mini-css-extract-plugin
export default {"HiresList":"styles_HiresList__0S4nb","title":"styles_title__rreOG","noHires":"styles_noHires__YV2+V"};